// Stock.jsx
import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Table,
  Button,
  FormControl,
  Modal,
  ListGroup,
} from "react-bootstrap";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import Contexts from "../../../context/Contexts";
import "../../../components/css/Stock.css"; // ⬅️ NUEVO
import * as XLSX from "xlsx";

export default function Stock() {
  const [articulos, setArticulos] = useState([]);
  const [searchSucursal, setSearchSucursal] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [articulosPerPage] = useState(100);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [searchDescription, setSearchDescription] = useState("");
  const [showInventarioModal, setShowInventarioModal] = useState(false);
  const [inventarios, setInventarios] = useState([]);
  const [selectedInventario, setSelectedInventario] = useState(null);
  const [calculandoStock, setCalculandoStock] = useState(false);
  const [cargandoSubcategorias, setCargandoSubcategorias] = useState(false);
  const [subcategoriasMedias, setSubcategoriasMedias] = useState([]);
  const [subcategoriasOmitidas, setSubcategoriasOmitidas] = useState([]);
  const [subcategoriasFiltradas, setSubcategoriasFiltradas] = useState([]);

  const context = useContext(Contexts.DataContext);
  const apiUrl = process.env.REACT_APP_API_URL;

  const subcategoriaPorCodigo = React.useMemo(() => {
    const mapa = new Map();

    (context.articulosTabla || []).forEach((articulo) => {
      const codigo = String(articulo.codigobarra ?? "").trim();

      if (!codigo) return;

      // Ajustar si el modelo ArticuloTabla utiliza otro nombre
      // para su clave foránea de subcategoría.
      const subcategoriaId = articulo.subcategoria_id;

      if (subcategoriaId != null) {
        mapa.set(codigo, String(subcategoriaId));
      }
    });

    return mapa;
  }, [context.articulosTabla]);

  useEffect(() => {
    setSelectedInventario(null);
  }, [searchSucursal]);

  const exportToExcel = (rows, filename) => {
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Stock");
    XLSX.writeFile(wb, filename);
  };

  const exportarStockExcel = () => {
    try {
      if (!filtered || filtered.length === 0) {
        alert("No hay datos para exportar.");
        return;
      }

      const rows = filtered.map((articulo) => ({
        codigo: articulo.codigo,
        descripcion: articulo.descripcion,
        cantidad: articulo.cantidad,
        ventas: articulo.ventas || 0,
        egresos: articulo.egresos || 0,
      }));

      exportToExcel(
        rows,
        `stock_${new Date().toISOString().slice(0, 10)}.xlsx`
      );
    } catch (error) {
      console.error("Error al exportar stock:", error);
      alert("Error al exportar stock.");
    }
  };
  const fetchSubcategoriasMedias = async () => {
    try {
      if (!startDate || !endDate || !searchSucursal) {
        setSubcategoriasMedias([]);
        setSubcategoriasOmitidas([]);
        return;
      }

      setCargandoSubcategorias(true);

      const response = await fetch(`${apiUrl}/obtenersubcategoriasmedias`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fechaDesde: startDate,
          fechaHasta: endDate,
          sucursalId: searchSucursal,
        }),
      });

      if (!response.ok) throw new Error("Error al obtener subcategorías");

      const data = await response.json();
      setSubcategoriasMedias(data);
      setSubcategoriasOmitidas([]);
    } catch (error) {
      console.error("Error al obtener subcategorías de medias:", error);
    } finally {
      setCargandoSubcategorias(false);
    }
  };

  const fetchInventarios = async () => {
    try {
      const response = await fetch(`${apiUrl}/obtenerinventariosfiltrados`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sucursalId: searchSucursal }),
      });
      if (response.ok) {
        const data = await response.json();
        setInventarios(data);
      }
    } catch (error) {
      alert("Error al obtener los inventarios: " + error.message);
    }
  };

  const handleSort = (columnName) => {
    setSortDirection(
      columnName === sortColumn && sortDirection === "asc" ? "desc" : "asc"
    );
    setSortColumn(columnName);

    const sorted = [...articulos].sort((a, b) => {
      let A = a[columnName];
      let B = b[columnName];
      if (typeof A === "undefined" || typeof B === "undefined") return 0;
      return sortDirection === "asc"
        ? String(A).localeCompare(String(B))
        : String(B).localeCompare(String(A));
    });

    setArticulos(sorted);
  };

  const isValidDate = (s) =>
    /^\d{4}-\d{2}-\d{2}$/.test(s) && new Date(s).toISOString().slice(0, 10) === s;

  useEffect(() => {
    fetchSubcategoriasMedias();
  }, [startDate, endDate, searchSucursal]);

  useEffect(() => {
    fetchSubcategoriasMedias();
  }, [startDate, endDate, searchSucursal]);

  const handleCalcularStock = async () => {
    try {
      if (!isValidDate(startDate) || !isValidDate(endDate)) {
        alert("Ingrese una fecha válida.");
        return;
      }

      if (!searchSucursal) {
        alert("Por favor, seleccione una sucursal antes de calcular stock.");
        return;
      }

      if (!selectedInventario) {
        alert("Por favor, seleccione un inventario antes de calcular stock.");
        return;
      }

      setCalculandoStock(true);

      const response = await fetch(`${apiUrl}/obtenerstock`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fechaDesde: startDate,
          fechaHasta: endDate,
          sucursalId: searchSucursal,
          inventarioId: selectedInventario.id,
          subcategoriasOmitidas,
        }),
      });

      if (!response.ok) throw new Error("Error al calcular stock");

      const data = await response.json();

      setArticulos(data);
      setCurrentPage(1);
    } catch (e) {
      console.error(e);
      alert("Error al calcular stock.");
    } finally {
      setCalculandoStock(false);
    }
  };

  const indexOfLast = currentPage * articulosPerPage;
  const indexOfFirst = indexOfLast - articulosPerPage;
  // const filtered = articulos.filter((a) =>
  //   (a.descripcion || "").toLowerCase().includes(searchDescription.toLowerCase())
  // );

  const filtered = articulos.filter((articulo) => {

    const coincideDescripcion =
      (articulo.descripcion || "")
        .toLowerCase()
        .includes(searchDescription.toLowerCase());

    const codigo = String(articulo.codigo ?? "").trim();

    const subcategoriaId = subcategoriaPorCodigo.get(codigo);

    const coincideSubcategoria =
      subcategoriasFiltradas.length === 0 ||
      (
        subcategoriaId !== undefined &&
        subcategoriasFiltradas.includes(subcategoriaId)
      );

    return coincideDescripcion && coincideSubcategoria;
  });

  const current = filtered.slice(indexOfFirst, indexOfLast);

  const nextPage = () => {
    if (currentPage < Math.ceil(filtered.length / articulosPerPage)) {
      setCurrentPage((p) => p + 1);
    }
  };
  const prevPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

  return (
    <Container className="stock-page">
      <h1 className="stock-title">Stock</h1>

      {/* Filtros principales */}
      <div className="stock-toolbar d-flex flex-wrap align-items-end gap-3 mb-3">
        <div className="mx-2 my-2">
          <label className="d-block">Sucursal</label>
          <FormControl
            as="select"
            value={searchSucursal}
            onChange={(e) => setSearchSucursal(e.target.value)}
            disabled={calculandoStock}
            className="form-control my-input"
            style={{ minWidth: 260 }}
          >
            <option value="">Seleccione una sucursal</option>
            {context.sucursalesTabla.map((s) => (
              <option key={s.id} value={s.id}>
                {s.nombre}
              </option>
            ))}
          </FormControl>
        </div>

        <div className="mx-2 my-2">
          <label className="d-block">DESDE</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            disabled={calculandoStock}
            className="form-control my-input text-center"
          />
        </div>

        <div className="mx-2 my-2">
          <label className="d-block">HASTA</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            disabled={calculandoStock}
            className="form-control my-input text-center"
          />
        </div>

        <div className="mx-2 my-2">
          <label className="d-block">&nbsp;</label>
          <Button
            onClick={() => {
              if (!searchSucursal) {
                alert("Seleccione una sucursal antes de elegir inventario.");
              } else {
                fetchInventarios();
                setShowInventarioModal(true);
              }
            }}
            className="stock-btn"
            disabled={calculandoStock}
          >
            Seleccionar Inventario
          </Button>
        </div>
      </div>

      {/* Inventario seleccionado + hint */}
      <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
        <div className="stock-selected mx-2 my-2">
          {selectedInventario
            ? `Inventario: Mes ${selectedInventario.mes}, Año ${selectedInventario.anio}`
            : "Ningún inventario seleccionado"}
        </div>
        <div className="text-muted small mx-2 my-2">
          Desde (inicio del período) / Hasta (fecha actual)
        </div>
      </div>

      {/* Subcategorías de medias a omitir */}
      <div className="d-flex flex-wrap align-items-end gap-3 mb-3">
        <div className="mx-2 my-2">
          <label className="d-block">Omitir subcategorías de medias</label>
          <FormControl
            as="select"
            multiple
            value={subcategoriasOmitidas}
            onChange={(e) => {
              const values = Array.from(
                e.target.selectedOptions,
                (option) => option.value
              );
              setSubcategoriasOmitidas(values);
            }}
            className="form-control my-input"
            style={{ minWidth: 260, minHeight: 110 }}
            disabled={calculandoStock}
          >
            {subcategoriasMedias.map((subcategoria) => (
              <option key={subcategoria} value={subcategoria}>
                {subcategoria}
              </option>
            ))}
          </FormControl>
          <small className="text-muted">
            Mantener Ctrl presionado para seleccionar varias.
          </small>
        </div>
      </div>

      {/* FILTRO DE SUBCATEGORÍAS PARA VISUALIZACIÓN */}

      <div className="stock-toolbar d-flex flex-wrap align-items-end gap-3 mb-3">

        <div className="mx-2 my-2">

          <label className="d-block">
            Filtrar stock por subcategorías
          </label>

          <FormControl
            as="select"
            multiple
            value={subcategoriasFiltradas}
            onChange={(e) => {

              const valores = Array.from(
                e.target.selectedOptions,
                (option) => option.value
              );

              setSubcategoriasFiltradas(valores);
              setCurrentPage(1);
            }}
            className="form-control my-input"
            style={{
              minWidth: 280,
              minHeight: 150
            }}
          >

            {(context.subcategoriasTabla || []).map(
              (subcategoria) => (

                <option
                  key={subcategoria.id}
                  value={String(subcategoria.id)}
                >
                  {subcategoria.descripcion}
                </option>

              )
            )}

          </FormControl>

          <small className="text-muted d-block mt-1">
            Mantené Ctrl para seleccionar varias.
            Sin selección se muestran todas.
          </small>

          <Button
            variant="outline-secondary"
            size="sm"
            className="mt-2"
            onClick={() => {
              setSubcategoriasFiltradas([]);
              setCurrentPage(1);
            }}
            disabled={subcategoriasFiltradas.length === 0}
          >
            Limpiar filtro
          </Button>

        </div>

        <div className="mx-2 my-2">
          <span className="text-muted">
            Productos encontrados: <strong>{filtered.length}</strong>
          </span>
        </div>

      </div>

      {/* Buscador por descripción */}
      <div className="d-flex flex-wrap align-items-end gap-3 mb-3">
        <div className="mx-2 my-2">
          <label className="d-block">Descripción</label>
          <FormControl
            type="text"
            placeholder="Buscar por descripción"
            value={searchDescription}
            onChange={(e) => setSearchDescription(e.target.value)}
            className="form-control my-input"
            style={{ minWidth: 260 }}
          />
        </div>
        <div className="mx-2 my-2">
          <label className="d-block">&nbsp;</label>
          <Button
            onClick={handleCalcularStock}
            className="stock-btn"
            disabled={calculandoStock}
          >
            {calculandoStock ? "Calculando..." : "Calcular Stock"}
          </Button>

          <Button
            onClick={exportarStockExcel}
            className="stock-btn ms-2"
            variant="success"
            disabled={calculandoStock || !filtered || filtered.length === 0}
          >
            Exportar Excel
          </Button>
        </div>
      </div>

      {/* Tabla */}
      <div className="stock-tablewrap table-responsive">
        <Table striped bordered hover className="mb-2 stock-table">
          <thead>
            <tr>
              <th className="st-th-sort" onClick={() => handleSort("codigo")}>
                Código
              </th>
              <th className="st-th-sort" onClick={() => handleSort("descripcion")}>
                Descripción
              </th>
              <th className="st-th-sort text-end" onClick={() => handleSort("cantidad")}>
                Stock
              </th>
              <th className="st-th-sort text-end" onClick={() => handleSort("ventas")}>Ventas</th>
              <th className="st-th-sort text-end" onClick={() => handleSort("egresos")}>Egresos</th>
            </tr>
          </thead>
          <tbody>
            {current.map((art, idx) => (
              <tr key={`${art.codigo}-${idx}`}>
                <td>{art.codigo}</td>
                <td>{art.descripcion}</td>
                <td className="text-end">{art.cantidad}</td>
                <td className="text-end">{art.ventas}</td>
                <td className="text-end">{art.egresos}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Paginación */}
      <div className="d-flex justify-content-center align-items-center stock-pager">
        <Button onClick={prevPage} disabled={currentPage === 1} variant="light">
          <BsChevronLeft />
        </Button>
        <span className="mx-2">
          Página {currentPage} de {Math.ceil(filtered.length / articulosPerPage) || 1}
        </span>
        <Button
          onClick={nextPage}
          disabled={
            currentPage === Math.ceil(filtered.length / articulosPerPage) || filtered.length === 0
          }
          variant="light"
        >
          <BsChevronRight />
        </Button>
      </div>

      {/* Modal de Inventarios */}
      <Modal show={showInventarioModal} onHide={() => setShowInventarioModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Seleccionar Inventario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListGroup>
            {inventarios.map((inv) => (
              <ListGroup.Item
                key={inv.id}
                action
                className="stock-inv-item"
                onClick={() => {
                  setSelectedInventario(inv);
                  setShowInventarioModal(false);
                }}
              >
                {`Mes: ${inv.mes}, Año: ${inv.anio}`}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Modal.Body>
      </Modal>
    </Container>
  );
}
